export default "__VITE_ASSET__BZyaUF_V__"